import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalRutVon } from "./ModalRutVon";

export const BtnRutVon = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Rút vốn"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-rut-von-v2.png" />
        </PopoversBootrap>
      </a>

      {show && (
        <ModalRutVon
          show={show}
          onHide={handleClose}
          customerId={item.CustomerID}
          item={item}
        />
      )}
    </>
  );
};
